import { MY } from 'config/fe-routes';
import ActivityIcon from 'public/icons/icn-activity.svg';
import ChatIcon from 'public/icons/icn-chat-bubble.svg';
import FollowIconOutlined from 'public/icons/icn-favorite.svg';
import FollowIconFilled from 'public/icons/icn-favorite-filled.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { openLoginModal } from 'store/actions/login.actions';
import { redirectTo } from 'utils/route-helpers';

import Button from '../../../ui-kit/Button/Button';
import OrderProcessingTime from '../../OrderProcessingTime';

type FavoriteIconProps = {
  filled?: boolean;
};

const FavoriteIcon = ({ filled = false }: FavoriteIconProps) => (filled ? <FollowIconFilled /> : <FollowIconOutlined />);

type ShopUserProfileFeedbackActionsProps = {
  isFollowingShop: boolean;
  likeCallback?: () => void;
  isLoggedIn?: boolean;
  activeSlug: string;
  lastActive?: string;
  showLocation: boolean;
  province?: string;
  location?: string;
  instagramTag?: string;
  formattedOrderProcessingTime?: string;
  holidayMode?: boolean | null;
};

const ShopUserProfileFeedbackActions = ({
  isFollowingShop,
  likeCallback,
  isLoggedIn,
  activeSlug,
  lastActive,
  showLocation,
  province,
  location,
  instagramTag,
  formattedOrderProcessingTime,
  holidayMode,
}: ShopUserProfileFeedbackActionsProps) => {
  const { t } = useTranslation();
  const instagramLink = instagramTag ? `https://instagram.com/${instagramTag}` : null;

  return (
    <div>
      <div className="shop-user-profile-feedback__actions">
        <Button
          startIcon={<FavoriteIcon filled={isFollowingShop} />}
          buttonType={isFollowingShop ? 'outlined' : 'primary'}
          onClick={() => {
            if (typeof likeCallback === 'function') {
              likeCallback();
            }
          }}
        >
          {isFollowingShop ? t('components.page-shop.following') : t('components.page-shop.follow')}
        </Button>
        <Button
          startIcon={<ChatIcon />}
          buttonType="outlined"
          onClick={() => {
            if (!isLoggedIn) {
              openLoginModal(true);

              return;
            }
            redirectTo(MY.CONVERSATION(activeSlug));
          }}
        >
          {t('common.chat')}
        </Button>
      </div>

      {holidayMode && (
        <div className="shop-user-profile-feedback__holiday-banner">
          <img src="/icons/icn-palm-tree.svg" className="palm-icon" alt="palm-tree" />
          <span>{t('pages.account.shop-on-holiday')}</span>
        </div>
      )}

      <div className="shop-user-profile-feedback__extra-info">
        <div className="shop-user-profile-feedback__extra-info-item">
          <ActivityIcon />
          <span className="shop-user-profile-feedback__extra-info-text">{lastActive}</span>
        </div>

        <OrderProcessingTime text={formattedOrderProcessingTime} classes="shop-user-profile-feedback__extra-info-item" />

        {showLocation && (
          <div className="shop-user-profile-feedback__extra-info-item">
            <img src="/icons/icn-location.svg" alt="profile" />
            <span>{[province, location].filter(Boolean).join(', ')}</span>
          </div>
        )}

        {instagramLink && (
          <div className="shop-user-profile-feedback__extra-info-item">
            <img src="/icons/icn-ig-thin.svg" alt="instagram" />
            <a className="" href={instagramLink} target="_blank" rel="noreferrer">
              <span className="">@{instagramTag}</span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopUserProfileFeedbackActions;
